import { gql, Reference, useMutation } from '@apollo/client'

import type { GQL_ID } from '@@types'

type AddFavoriteProductVariables = {
  product_id: GQL_ID
}

export const GQL_MUTATION_ADD_FAVORITE_PRODUCT = gql`
  mutation addFavoriteProduct ($product_id: ID!) {
    addFavoriteProduct(product_id: $product_id)
  }
`

export const useMutateAddFavoriteProduct = () => {
  return useMutation<boolean, AddFavoriteProductVariables>(GQL_MUTATION_ADD_FAVORITE_PRODUCT, {
    update: (cache, _result, options) => {
      const productId = options.context?.productId
      if (!productId) return

      cache.modify({
        id: `Product:${productId}`,
        fields: {
          isFavorite: () => true,
        },
      })

      cache.modify({
        fields: {
          favoriteProducts (existing, { readField, toReference }) {
            const newRef = toReference({
              __typename: 'Product',
              id: productId,
            })
            const exists = existing.edges.some(
              (ref: Reference) => readField('id', ref) === productId,
            )

            if (exists) return existing

            return {
              ...existing,
              edges: [ newRef, ...existing.edges ],
            }
          },
        },
      })

      cache.modify({
        fields: {
          favoriteProducts (existing = {}) {
            return {
              ...existing,
              pageInfo: {
                ...existing.pageInfo,
                total: (existing.pageInfo?.total ?? 0) + 1, // или -1 при удалении
              },
            }
          },
        },
      })
    },
  })
}
